import $ from 'jquery';
import Flickity from 'flickity';
import debounce from 'lodash/debounce';
import { breakpoints } from "../utils";

export default class {
  constructor(el) {
    const self = this;
    self.$el = $(el);
    self.$tabsContainer = self.$el.find(".js-tabbed-content__tabs");
    self.$tabs = self.$el.find(".js-tabbed-content__tab");
    self.$tabContents = self.$el.find(".js-tabbed-content__tab-content");
    self.state = null;
    self.resize = debounce(self.resize.bind(self), 250);

    $(window).on("resize", self.resize).trigger("resize");

    self.$tabs.on("click", function(event){
      const $tab = $(this);
      $.proxy(self.select, self)($tab.index());
      event.preventDefault();
    });
    $('.js-modal__toggle').on("click", () => {
      self.resize();
      $(window).trigger('resize');
      $(window).on('resize', self.resize).trigger('resize');
      self.resize = debounce($(el).resize.bind(self), 250);
    });

    self.select(0);
  }
  select(index) {
    const self = this;

    self.$tabs.removeClass('is-active');
    self.$tabContents.removeClass('is-active');

    self.$tabs.eq(index).addClass('is-active').trigger('tabActive');
    self.$tabContents.eq(index).addClass('is-active');
    if (self.flkty && $(window).width() < breakpoints.tablet) {
      self.flkty.select(index)
    }
  }
  resize() {
    const self = this;
    if($(window).width() < breakpoints.tablet && self.state !== "mobile") {
      self.flkty = new Flickity(self.$tabsContainer.get(0), {
        prevNextButtons: false,
        contain: false,
        setGallerySize: true,
        pageDots: false,
      });
      self.state = "mobile";
    } else if($(window).width() >= breakpoints.tablet && self.state !== "desktop") {
      if(self.flkty){
        self.flkty.destroy()
      }
      self.state = "desktop";
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/TabbedContent.js